export default __webpack_public_path__ + "1c875b7bcefd66713fb91ef828f9bbea.svg";